/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from 'react';
import { Form, Input, Modal, DatePicker, message, Select } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { DataService } from '../../../config/dataService/dataService';
import { CompSelector } from '../../common';
import { FORM_HIDE_TIMEOUT_SECONDS } from '../../../config/config';

const initialState = {
  username: '',
  full_name: '',
  email: '',
  password: '',
  contact: '',
};
const { Option } = Select;

const FormDialog = ({ showDialog, disableOutSideCLose = false, isEdit = false, setReload, editId }) => {
  const [form] = Form.useForm();
  const [compID, setCompID] = useState(null)
  const [compTitle, setCompTitle] = useState(null)
  const [userRole, setUserRole] = useState(null)
  const [busy, setBusy] = useState(false);
  const [roles, setRoles] = useState([]);

  const fetchData = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/users/get-by-id', { id });
      if (response.data.status) {
        const mData = response.data.data;
        setUserRole(mData.role_id)
        if (mData.comp_id) {
          setCompTitle(mData.comp_name)
          setCompID(mData.comp_id)
        }

        form.setFieldsValue({
          ...mData,
        });
      } else {
        message.error(response.data.message || response.message)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching company data:', error);
      message.error(error.message)
    }
  };

  const fetchUserRoles = async () => {
    try {
      setBusy(true);
      const response = await DataService.post('/users/get-roles');
      if (response.data.status) {
        const mData = response.data.data;
        setRoles(mData);
      } else {
        message.error(response.data.message || response.message)
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching company data:', error);
      message.error(error.message)
    }
  };

  const handleSubmit = async (values) => {
    try {
      setBusy(true);
      const payload = {
        ...values,
        comp_id: compID,
        role_id: userRole
      };

      const endpoint = isEdit ? '/users/update' : '/users/create';
      const response = await DataService.post(endpoint, { ...payload, id: editId });

      if (response.data.status) {
        message.success(response.data.message, FORM_HIDE_TIMEOUT_SECONDS, () => {
          showDialog(false);
          setReload(true);
        });
      } else {
        setBusy(false);
        message.error(`Error: ${response.data.message}`)
      }
    } catch (error) {
      setBusy(false);
      message.error(`Error submitting data: ${error.message}`)
    }
  };

  useEffect(() => {
    fetchUserRoles();
  }, [])

  useEffect(() => {
    if (isEdit && editId) {
      fetchData(editId);
    }
  }, [isEdit, editId]);


  // console.log('form', form)
  return (
    <Modal
      open
      title={isEdit ? 'Edit Record' : 'Add Record'}
      okText={isEdit ? 'Update' : 'Create'}
      cancelText="Cancel"
      width='50%'
      centered
      confirmLoading={busy}
      onCancel={(event) => {
        const { target, keyCode } = event
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false)
        if (keyCode === 27) showDialog(false)
      }}
      onOk={() => form.submit()}
      cancelButtonProps={{
        disabled: busy
      }}
      destroyOnClose
      closable={false}
    >
      <Form
        layout="horizontal"
        form={form}
        onFinish={handleSubmit}
        disabled={busy}
        labelCol={{ span: 6 }} // Adjust label width
        wrapperCol={{ span: 16 }} // Adjust input width
        initialValues={initialState}
      >
        <Form.Item
          name="username"
          label="Username"
          rules={[
            { required: true, min: 4, message: 'Please input the username!' },
            {
              pattern: /^[a-z][a-z0-9_]*$/,
              message:
                'Username must start with a letter, contain only lowercase letters, numbers, and underscores, and have no spaces or special characters.',
            },
            {
              min: 4,
              message: 'Username must be at least 4 characters long.',
            },
          ]}
        >
          <Input placeholder="Enter Username" />
        </Form.Item>
        <Form.Item
          name="full_name"
          label="Full Name"
          rules={[
            { required: true, min: 5, message: 'Please input the full name!' },
          ]}
        >
          <Input placeholder="Enter Full Name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[{ type: 'email', required: true, message: 'Please input the email!' }]}
        >
          <Input placeholder="Enter Email" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[
            {
              required: !isEdit,
              message: 'Please input your password!',
            },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/,
              message:
                'Password must contain at least 8 characters, including 1 lowercase, 1 uppercase, 1 digit, and 1 special character.',
            },
          ]}
        >
          <Input.Password
            placeholder="Enter Password"
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>
        <Form.Item
          name="contact"
          label="Contact"
          rules={[
            { required: true, min: 4, message: 'Please input the contact number !' },
          ]}
        >
          <Input placeholder="Enter Contact #" />
        </Form.Item>
        <Form.Item
          name="role_id"
          label="User Role"
          rules={[
            {
              required: true, min: 4, validator: () => {
                if (!userRole) {
                  return Promise.reject(new Error('Please select a role !'));
                }
                return Promise.resolve();
              }
            },
          ]}
        >
          <Select
            placeholder="Select a role"
            onChange={value => {
              setCompID(null)
              setCompTitle(null)
              setUserRole(value)
            }}
            value={userRole}
            defaultValue={userRole}
            allowClear
          >
            {roles.map((item) => (
              <Option key={item.id} value={item.id} >
                {item.title}
              </Option>
            ))}
          </Select>
        </Form.Item>
        {(userRole === 3) && (
          <Form.Item
            name="comp_id"
            label="select company"
            rules={[
              {
                required: true, validator: () => {
                  if (!compID) {
                    return Promise.reject(new Error('Please select a company !'));
                  }
                  return Promise.resolve();
                }
              },
            ]}
          >
            <CompSelector onItemSelected={setCompID} defaultValue={compTitle} />
          </Form.Item>
        )}
      </Form>

    </Modal>
  );
};

export default FormDialog;
